
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { blockUi, addHeader } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { OperacaoCreditoLivre } from 'src/app/model/operacao-credito-livre.model';
import { zip } from 'gzip-js';
import { Base64 } from 'js-base64';
import { HttpParams } from '@angular/common/http';
import { OperacaoCreditoLivreDominioModalidade } from 'src/app/model/operacao-credito-livre-dominio-modalidade';
import { OperacaoCreditoLivreDominioIndexador } from 'src/app/model/operacao-credito-livre-dominio-indexador';

@Injectable({
  providedIn: 'root'
})
export class OperacaoCreditoLivreService extends FgiBackEndService<OperacaoCreditoLivre> {

    getNewEntity() {
    return new OperacaoCreditoLivre();
  }

    protected getResourceURL(): string {
    return 'front/credito-livre/operacoes';
  }

/*    getOperacoes(params?: any, options?: any): any {
    return this.http.get(`${this.BASE_URL}`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<OperacaoCreditoLivre>>;
  }*/

  enviarOperacoes(operacoes, apenasValidar: boolean): Observable<Array<OperacaoCreditoLivre>> {

    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    const usaZip = true;
    let encoded;
    if (usaZip) {
      addHeader(options, 'Content-Type', 'application/json');
      addHeader(options, 'Content-Encoding', 'gzip+base64');
      encoded = Base64.fromUint8Array(new Uint8Array(zip(JSON.stringify(operacoes))));
    } else {
      encoded = operacoes;
    }

    this.mostrarMemoria('enviarOperacoes');
    return this.http.post(`${this.BASE_URL}/lote`, encoded, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<Array<OperacaoCreditoLivre>>;
  }

  enviarLiberacoes(liberacoes, apenasValidar: boolean): Observable<Array<OperacaoCreditoLivre>> {

    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}/liberacoes/lote`, liberacoes, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<Array<OperacaoCreditoLivre>>;
  }

  enviarAmortizacoes(amortizacoes, apenasValidar: boolean): Observable<Array<OperacaoCreditoLivre>> {

    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}/front/protocolos-arquivos`, amortizacoes, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<Array<OperacaoCreditoLivre>>;
  }

    save(operacao: OperacaoCreditoLivre, apenasValidar: boolean): Observable<OperacaoCreditoLivre> {

    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}`, operacao, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<OperacaoCreditoLivre>;
  }

    update(regra: OperacaoCreditoLivre, options?: any): Observable<OperacaoCreditoLivre> {
    throw new Error('Update nao suportado. Atualizoes em dados de operacoes devem ser feitas via retificacoes ou aditivos');
  }

  aditar(operacao: OperacaoCreditoLivre): Observable<OperacaoCreditoLivre> {
    return this.http.post(`${this.BASE_URL}/${operacao.id}/aditivo`, operacao, blockUi()).pipe(
           catchError((e) => this.handleError(e))) as Observable<OperacaoCreditoLivre>;
  }

  retificar(operacao: OperacaoCreditoLivre): Observable<OperacaoCreditoLivre> {
    return this.http.post(`${this.BASE_URL}/${operacao.id}/retificar`, operacao, blockUi()).pipe(
           catchError((e) => this.handleError(e))) as Observable<OperacaoCreditoLivre>;
  }

  exportarOperacao(id): Observable<string> {
    return this.http.get(`${this.BASE_URL}/exportacao/${id}`).pipe(
        catchError((e) => this.handleError(e))) as Observable<string>;
  }

  private mostrarMemoria(item: string) {
    let perf: any = window.performance;
    if (perf.memory) {
      let mem = perf.memory;
      console.log(item,
                  "- Memory -",
                  "jsHeapSizeLimit:", mem.jsHeapSizeLimit,
                  "totalJSHeapSize:", mem.totalJSHeapSize,
                  "usedJSHeapSize:", mem.usedJSHeapSize);
    }
  }

  buscaDominioModalidades(codigoTipoOperacao: string, dataContratacao?: string): Observable<OperacaoCreditoLivreDominioModalidade[]> {
    let params = new HttpParams();
    params = params.append('codigoTipoOperacao', codigoTipoOperacao);
    if (dataContratacao != null) {
      params = params.append('dataContratacao', dataContratacao);
    }

    return this.http.get(`${this.BASE_URL}/modalidades`, { params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<OperacaoCreditoLivreDominioModalidade[]>;
  }

  buscaDominioIndexadores(codigoTipoOperacao: string, dataContratacao: string, modalidadeCodigo: string): Observable<OperacaoCreditoLivreDominioIndexador[]> {
    let params = new HttpParams();
    params = params.append('codigoTipoOperacao', codigoTipoOperacao);
    if (dataContratacao != null) {
      params = params.append('dataContratacao', dataContratacao);
    }
    params = params.append('modalidadeCodigo', modalidadeCodigo);
    return this.http.get(`${this.BASE_URL}/indexadores`, { params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<OperacaoCreditoLivreDominioIndexador[]>;
  }

}

